import React from "react";
import { BrowserRouter as Router, Link, Route, Routes } from "react-router-dom";
import AdminScreen from "./screens/admin.screen";
import HomeScreen from "./screens/home.screen";
import ImpressumScreen from "./screens/impressum.screen";
import DatenschutzScreen from "./screens/datenschutz.screen";
import DeleteAccountScreen from "./screens/delete-account.screen";
import { FooterContent, NavContent, NavLeft, NavRight } from "./app.style";

import logoLight from "./assets/KP_icon.png";
import logoDark from "./assets/KP_logo_dark.png";

const App = () => {
  return (
    <Router>
      <header>
        <nav>
          <NavContent>
            <NavLeft>
              <a href="/#hero">
                <img width={"32px"} src={logoLight} alt={"Brand Logo"} />
              </a>
              <ul>
                {/*<li><a href="/#features">Features</a></li>*/}
                {/*<li><a href="/#roadmap">Roadmap</a></li>*/}
                {/*<li><a href="/#faq">FAQ</a></li>*/}
              </ul>
            </NavLeft>
            <NavRight></NavRight>
          </NavContent>
        </nav>
      </header>

      <Routes>
        <Route path="/" element={<HomeScreen />} />
        <Route path="/admin" element={<AdminScreen />} />
        <Route path="/impressum" element={<ImpressumScreen />} />
        <Route path="/datenschutz" element={<DatenschutzScreen />} />
        <Route path="/konto-loeschen" element={<DeleteAccountScreen />} />
      </Routes>

      <footer>
        <FooterContent>
          <a href="/#hero">
            <img width={"150px"} src={logoDark} alt={"Brand Logo"} />
          </a>
          <ul>
            {/*<li><a href="/#hero">Home</a></li>*/}
            {/*<li><a href="/#features">Features</a></li>*/}
            {/*<li><a href="/#roadmap">Roadmap</a></li>*/}
            {/*<li><a href="/#faq">FAQ</a></li>*/}
          </ul>
          <ul>
            <li>
              <Link to="/konto-loeschen">App-Konto löschen</Link>
            </li>
            <li>
              <Link to="/admin">Admin Bereich</Link>
            </li>
          </ul>
          <ul>
            <li>
              <Link to="/impressum">Impressum</Link>
            </li>
            <li>
              <Link to="/datenschutz">Datenschutzbestimmungen</Link>
            </li>
          </ul>
        </FooterContent>
        <p style={{ margin: 0, }}>&copy; 2025 Katapult-App. Alle Rechte vorbehalten.</p>
      </footer>
    </Router>
  );
};

export default App;
